<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="92" height="39" viewBox="0 0 92 39">
        <g id="Groupe_15" data-name="Groupe 15" transform="translate(-400 -784)">
            <rect id="Rectangle_313" data-name="Rectangle 313" width="92" height="39" rx="6" transform="translate(400 784)" fill="#a8a8a8" />
            <g id="Rectangle_315" data-name="Rectangle 315" transform="translate(437.8 794.5)" fill="#e85446" stroke="#707070" stroke-width="1">
                <rect width="23" height="12" stroke="none" />
                <rect x="0.5" y="0.5" width="22" height="11" fill="none" />
            </g>
            <path
                id="Icon_material-picture-as-pdf"
                data-name="Icon material-picture-as-pdf"
                d="M30,3H12A3.009,3.009,0,0,0,9,6V24a3.009,3.009,0,0,0,3,3H30a3.009,3.009,0,0,0,3-3V6A3.009,3.009,0,0,0,30,3ZM17.25,14.25A2.247,2.247,0,0,1,15,16.5H13.5v3H11.25v-9H15a2.247,2.247,0,0,1,2.25,2.25Zm7.5,3A2.247,2.247,0,0,1,22.5,19.5H18.75v-9H22.5a2.247,2.247,0,0,1,2.25,2.25Zm6-4.5H28.5v1.5h2.25V16.5H28.5v3H26.25v-9h4.5ZM13.5,14.25H15v-1.5H13.5ZM6,9H3V30a3.009,3.009,0,0,0,3,3H27V30H6Zm15,8.25h1.5v-4.5H21Z"
                transform="translate(428 785.5)"
                fill="#f4f4f4"
            />
        </g>
    </svg>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// IconePdf.vue?75e30c2f